module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "vux-swipeout-button",
    class: {
      'vux-swipeout-button-primary': _vm.type === 'primary', 'vux-swipeout-button-warn': _vm.type === 'warn', 'vux-swipeout-button-default': _vm.type === 'default'
    },
    style: ({
      width: (_vm.width + "px"),
      backgroundColor: _vm.backgroundColor
    }),
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onButtonClick
    }
  }, [_vm._t("default", [_vm._v(_vm._s(_vm.text))])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a79b955a"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/swipeout/swipeout-button.vue
// module id = 545
// module chunks = 4